// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_eo-a";
export var fulfillmentFormRail = "_eo-9";
export var headerTitleRow = "_eo-c";
export var orderDetailsWrapper = "_eo-7";
export var orderLinkTrigger = "_eo-2";
export var paymentInformationGrid = "_eo-h";
export var paymentSummaryColumn = "_eo-i";
export var shipmentContainer = "_eo-b";
export var shipmentDetailsMainPane = "_eo-8";
export var shipmentNavigationCard = "_eo-5";
export var shipmentNavigationRail = "_eo-3";
export var shipmentNavigationRailHeader = "_eo-4";
export var shipmentSummaryFact = "_eo-e";
export var shipmentSummaryGrid = "_eo-d";
export var shipmentSummaryMetadataRow = "_eo-f";
export var shipmentSummaryTags = "_eo-g";
export var shipmentWorkspace = "_eo-0";
export var shipmentWorkspaceContent = "_eo-6";
export var shipmentWorkspaceHeader = "_eo-1";